// returns a Promisized version of Image() api
export default ({ decode = true, crossOrigin = '' }) => (src) => {
    return new Promise((resolve, reject) => {
        const i = new Image();
        if (crossOrigin)
            i.crossOrigin = crossOrigin;
        i.onload = () => {
            decode && i.decode ? i.decode().then(resolve).catch(reject) : resolve();
        };
        i.onerror = reject;
        i.src = src;
    });
};
//# sourceMappingURL=imagePromiseFactory.js.map